import { resizeGame } from '@pascal/pascal-core';

const maxHeight = 846;
const maxWidth = 1494;
const target = document.querySelector('.root');
export const resizeGameHandler = () => {
  resizeGame(maxHeight, maxWidth, target);
};
